module.exports = __webpack_public_path__ + "img/video-preview.f03ceb33.webp";